<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong> Mobile Log </strong>
           
          </div>
         
            <form @submit.prevent="validateForm2('form-2')" data-vv-scope="form-2">
<!--                           <input class="input" type="text" name="apiname" v-model="customerSearch.apiname" placeholder="Enter API Name">
   <input class="input" type="text" name="deliveryagentfirstname" v-model="customerSearch.deliveryagentfirstname" placeholder="Enter First Name">
    <input class="input" type="text" name="deliveryagentlastname" v-model="customerSearch.deliveryagentlastname" placeholder="Enter Last Name">
  <input class="input" type="text" name="deliveryagentmobilenumber" v-model="customerSearch.deliveryagentmobilenumber" placeholder="Enter Mobile Number">
 -->
          <b-row class="mb-4">

            <b-col md="3" class="my-1">
              <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col md="3" class="my-1">
              <b-form-group label-cols-sm="3" label="Date" class="mb-0">
                 <v-date-picker mode='single' class="input" input-class="dateInput" :available-dates='{ start: null, end: new Date() }' name="createddate" v-model='createddate'>
                </v-date-picker>
              </b-form-group>
            </b-col>
            <b-col md="3" class="my-1">
              <b-form-group label="Delivery Agent"  :label-cols="4" >
                   <b-form-select class="form-control input"  name="deliveryagentmobilenumber" v-model="customerSearch.deliveryagentmobilenumber"  v-validate="'required'" :class="{'input': true, }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="customer.deliveryagentmobilenumber" v-for="customer in deliveryagentarr"  :disabled="customer.capacityforallocation== 0">{{ customer.deliveryagentfirstname | capitalize }} {{ customer.deliveryagentlastname | capitalize }} - {{ customer.deliveryagentmobilenumber | capitalize }}</option>
                   </b-form-select>
                  <span v-show="errors.has('form-1.shipmentid')" class="help is-danger">{{ errors.first('form-1.shipmentid') }}</span>             
                </b-form-group>              

            </b-col>
             <b-col md="3" class="my-1">
                <button  class="btn btn-primary btn-md mr-2" size="md" type="submit" >Search</button>
                <button class="btn btn-danger btn-md" type="button" @click="searchclear">Clear</button>
                </b-col>
          </b-row>  
          </form>
          <b-table show-empty stacked="md" :busy="isBusy"  :items="items"  :fields="fields"  :current-page="currentPage" :bordered="bordered"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
              <template slot="createddate" slot-scope="row">
                {{ row.item.createddate | datechange}}
              </template>
          </b-table>
          <b-col md="6" class="my-1" v-if="this.totalRows > 10">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-col> 
        </b-card>
      </b-col>
    </b-row>      
  </div>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function() {
    return {
      isBusy: false,  
      name: 'mobilelogging',
      data: [],
      clientdata: [],
      customerSearch: {},
      items:[],
      seen: true,
      bordered: true,
      selected:'',
      createddate: new Date(),
      verificationCodeToggleInfo: false,
      fields: [
          { key: 'daactivitylogid', label: 'Id', sortable: true },
          { key: 'deliveryagentmasterid', label: 'agent Id', sortable: true},
          { key: 'deliveryagentfirstname', label: 'First Name', sortable: true},
          { key: 'deliveryagentlastname', label: 'Last Name', sortable: true},         
          { key: 'apiname', label: 'apiname' },    
          { key: 'createddate', label: 'createddate' ,sortDirection: 'desc'}         
        ],
      totalRows: 0,
      currentPage: 1,
      perPage:  10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'desc',
      filter: null,
       deliveryagentarr: [],
    }
  },
  created: function() {
     var createddate = this.formatDate(this.createddate);
      this.customerSearch.createddate = `${createddate}`;
      // console.log(this.customerSearch);
      this.displaydata(JSON.stringify(this.customerSearch))
    //$('#createddate').val('');
    //document.getElementsByName('createddate').value = "";
    //document.getElementByName('createddate').value = "";
  },
   computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
  methods: {
    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
    },
    searchclear: function() {
      this.customerSearch = {}
      this.errors.clear('form-2')
       this.displaydata();
      this.$router.push('/mobilelogging');
    },
    validateForm2: function(scope) {
      //var createddate = this.createddate;
      var createddate = this.formatDate(this.createddate);
      this.customerSearch.createddate = `${createddate}`;
      // console.log(this.customerSearch);
      this.displaydata(JSON.stringify(this.customerSearch))
    },
    formatDate: function(date) {
      var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
    search: function() {     
      var search1 = document.getElementById("search");
      search1.style.display = "block";
      this.seen = !this.seen;      
      this.searchclear();
    },
    refresh:function(){
      var search1 = document.getElementById("search");
      search1.style.display = "none";
      this.seen = !this.seen;
    },
    displaydata: function(serchData) {
      //  var userdata = localStorage.getItem('userData')
      // var userInfo = JSON.parse(userdata)
      // const deliveryagent = {
      //   deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
      //   isactive: '1'
      // }
       const deliveryagent = {};
      this.$http.post(`${CONSTANTS.API_URL}/DeliveryAgentMaster.svc/DeliveryAgentMasterGetAll`, deliveryagent)
        .then((result) => {
          this.deliveryagentarr = result.body
        })
        .catch((ex) => {
          console.log('error', ex)
        })

       this.isBusy = true;
      const customerGetAllobj = serchData || {}
      this.$http
        .post(
          `${CONSTANTS.API_URL}/MobileLogginggetall`,
          customerGetAllobj
        )
        .then(result => {
          if (
            (result.body[0].returnmsg &&
              result.body[0].returnmsg === 'UnSuccessful') ||
            result.body[0].returnmsg === 'No Records Founnd'
          ) {
            this.isBusy = !this.isBusy;
            this.items  = [];
            this.totalRows = 0
           // alert('Result not found')
          } else {
               
           //  var results=[];
           //  var results =result.body;

           //  var arr = [];

           //  var searchResults=[];
           //  var obj = {};
           //  results.forEach((element) => {           
           //    obj[element.deliveryagentmasterid] = element;
           //    //  searchResults.push(element);
           //  });        
           
           // console.log(obj);




            this.isBusy = !this.isBusy;
            this.data = result.body;
            this.items  = result.body;
            this.totalRows = result.body.length
            //console.log("data::", this.data);
          }
        })
        .catch(ex => {
          console.log('error', ex)
        })
    }
  },
  filters: {
    datechange: function(value) {       
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+' : '+ " " + strTime;
      }
    },
     capitalize: function(value) {
            return value.toUpperCase() || "";
        }
  }
}
</script>

<style lang="css">
.table tr th{
  color:#fff!important;
}

.table button{
  background:	#B0C4DE!important;
  color:#000!important;
}
.table tr:hover{
  background:#efefef;
}
tbody tr:nth-child(even) {background: #f2f2f2}
tbody tr:nth-child(odd) {background: #FFF}
.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #fff;
}
hr {
  margin-bottom: 0px;
}
.error {
  color: red;
}
button.editbtn{
  border:none;
  background:transparent!important;
}
</style>
